/**
 * Mantine theme for patient-facing surveys (deep plum primary).
 * @agentic members
 */

import { createTheme, type MantineColorsTuple } from "@mantine/core";

const plum: MantineColorsTuple = [
  "#faf6fc",
  "#ede5f2",
  "#dac8e5",
  "#c5a9d4",
  "#ae88c0",
  "#9467aa",
  "#6e4387",
  "#553668",
  "#3e2a4f",
  "#2a1c36",
];

/**
 * Shared theme for the members app shell and forms.
 * @agentic members
 */
export const surveyTheme = createTheme({
  primaryColor: "plum",
  primaryShade: 8,
  defaultRadius: "lg",
  colors: { plum },
  fontFamily:
    '"Plus Jakarta Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  headings: {
    fontFamily:
      '"Crimson Pro", Georgia, "Times New Roman", "Liberation Serif", Times, serif',
    fontWeight: "300",
  },
  other: {
    textColor: "#391640",
  },
});
